module.exports = "/images/info.svg?edcc60e3404e15f0982050f8a5faa4e2";